import { useState } from "react";
import { ChildById } from "../ComponentRenderer";
import { ComponentProps } from "../registry";
import { resolveChildRef } from "../../path";
import { ChildRef } from "../../types";

export function Modal({ fields, scope }: ComponentProps) {
  const [open, setOpen] = useState(false);
  const entryId = resolveChildRef(fields.entryPointChild as ChildRef);
  const contentId = resolveChildRef(fields.contentChild as ChildRef);

  return (
    <>
      <span className="a2-modal-trigger" onClick={() => setOpen(true)}>
        <ChildById id={entryId} scope={scope} />
      </span>
      {open && (
        <div className="a2-modal-backdrop" onClick={(e) => {
          if (e.target === e.currentTarget) setOpen(false);
        }}>
          <div className="a2-modal-panel">
            <button
              className="a2-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >×</button>
            <ChildById id={contentId} scope={scope} />
          </div>
        </div>
      )}
    </>
  );
}
